module.exports = __webpack_public_path__ + "static/media/155.ec298c4a.jpg";